import React from 'react';
import moment from 'moment';
import DanhSachDoanDongNguoi from './DanhSachDoanDongNguoi.jsx';
import {Text} from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';

class ThongTinNguoiDungDon extends React.Component {

  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps})
  }

  render() {
    let ListNguoiDungDon = ''
    if(this.props.listNguoiDungDon) {
      ListNguoiDungDon = this.props.listNguoiDungDon.map((item, i) => {
        return (
          <div key={i}>
            <ShowIf condition={this.props.loaiNguoiDungDon == "CO_QUAN_TO_CHUC"}>
              <div className="items-form mb10">
                <div className="rows">
                  <Text
                    className="col-4"
                    label="Tên cơ quan/Tổ chức:"
                    value={item.tenCoQuan ? item.tenCoQuan : ''} />
                  <Text
                    className="col-4"
                    label="Địa chỉ cơ quan:"
                    value={item.diaChiCoQuan ? item.diaChiCoQuan : ''} />
                  <Text
                    className="col-4"
                    label="Điện thoại cơ quan:"
                    value={item.soDienThoaiCoQuan ? item.soDienThoaiCoQuan : ''} />
                </div>
              </div>
            </ShowIf>
            <ShowIf condition={this.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI"}>
              <ShowIf condition={ this.props.listNguoiDungDon.length == 1}>
                <h2 className="title-12 txt-heading mb15 pl5 pr5">Người đại diện</h2>
              </ShowIf>
              <ShowIf condition={this.props.listNguoiDungDon.length > 1}>
                <h2 className="title-12 txt-heading mb15 pl5 pr5">Người đại diện {i+1}</h2>
              </ShowIf>
            </ShowIf>
            <ShowIf condition={this.props.loaiNguoiDungDon == "CO_QUAN_TO_CHUC"}>
              <h2 className="title-12 txt-heading mb15 pl5 pr5">Người đại diện</h2>
            </ShowIf>
            <ShowIf condition={this.props.loaiNguoiDungDon == "CA_NHAN"}>
              <ShowIf condition={ this.props.listNguoiDungDon.length == 1}>
                <h2 className="title-12 txt-heading mb15 pl5 pr5">Người đứng đơn</h2>
              </ShowIf>
              <ShowIf condition={this.props.listNguoiDungDon.length > 1}>
                <h2 className="title-12 txt-heading mb15 pl5 pr5">Người đứng đơn {i+1}</h2>
              </ShowIf>
            </ShowIf>
            <div className="group-box">
              <div className="items-form">
                <div className="rows mb10">
                  <Text className="col-input" label="Họ và tên:" value={item.hoVaTen}/>
                  <Text className="col-input" label="Ngày sinh:" value={item.ngaySinh ? moment(item.ngaySinh).format('DD/MM/YYYY') : ''}/>
                  <Text className="col-input" label="Số điện thoại:" value={item.soDienThoai}/>
                  <Text className="col-40" label="Giới tính:" value={item.gioiTinh ? 'Nam' : 'Nữ'}/>
                </div>
              </div>
              <div className="items-form">
                <div className="rows mb10">
                  <Text className="col-input" label="Số CMND/ Hộ chiếu:" value={item.soCMNDHoChieu}/>
                  <Text className="col-input" label="Ngày cấp:" value={item.ngayCap ? moment(item.ngayCap).format('DD/MM/YYYY') : ''}/>
                  <Text className="col-input" label="Nơi cấp:" value={item.noiCapCMNDInfo ? item.noiCapCMNDInfo.ten : ''}/>
                  <Text className="col-input" label="Quốc tịch:" value={item.quocTichCongDan ? item.quocTichCongDan.ten : ''}/>
                  <Text className="col-input" label="Dân tộc:" value={item.danTocCongDan ? item.danTocCongDan.ten : ''}/>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text className="col-input" label="Tỉnh:" value={item.tinhThanhCongDan ? item.tinhThanhCongDan.ten : ''}/>
                  <ShowIf condition={item.quanHuyenCongDan != null || item.phuongXaCongDan != null || (item.toThon != '' && item.toThon != null)}>
                    <Text className="col-input" label="Quận/Huyện:" value={item.quanHuyenCongDan ? item.quanHuyenCongDan.ten : ''}/>
                    <Text className="col-input" label="Phường/Xã:" value={item.phuongXaCongDan ? item.phuongXaCongDan.ten : ''}/>
                  </ShowIf>
                  <Text className="col-w40" label="Địa chỉ:" value={item.diaChi || ''}/>
                 </div>
              </div>
              <div className="pl5 pr5 pt10 mb15"><div className="line-border"></div></div>
            </div>
          </div>
        )
      });
    } else {
      ListNguoiDungDon = (<div></div>)
    }
    return (
      <div className="box-items mb0">
        <div className="box-forward">
          <div className="container-box">
            <div className="title">
              <div className="rows pt5">
                  <div className="col-12">
                    <h3 className="mb15">THÔNG TIN NGƯỜI ĐỨNG ĐƠN/VỤ VIỆC</h3>
                  </div>
              </div>
            </div>
            <div className="group-box no-border">
              <div className="items-form">
                  <div className="rows mb10">
                    <Text className="col-input" label="Loại người đứng đơn:" value={this.props.loaiNguoiDungDonInfo ? this.props.loaiNguoiDungDonInfo.ten : ''} />

                    {this.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? (
                      <div>
                        <Text className="col-input" label="Số người:" value={String(this.props.soNguoi)} />
                        <Text className="col-input" label="Số người đại diện:" value={String(this.props.listNguoiDungDon.length)} />
                      </div>
                    ):null}
                  </div>
              </div>
            </div>

            {ListNguoiDungDon}
            {this.props.loaiNguoiDungDon == "DOAN_DONG_NGUOI" ? (
              <DanhSachDoanDongNguoi listDoanDiCung={this.props.listDoanDiCung}/>
            ):null}
          </div>
        </div>
      </div>
    );
  }
}

export default ThongTinNguoiDungDon;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ThongTinNguoiDungDon.jsx